'use client';
import styled, { css, keyframes } from 'styled-components';

const getWiggleAnimation = (duration = 0.5, delay) => {
  const totalDuration = duration + delay;

  const wigglePercentage = (duration / totalDuration) * 100;

  //* Calculate keyframe percentages ahead of time to avoid linting errors
  const start = `0% { transform: rotate(0deg); }`;
  const firstQuarter = `${
    wigglePercentage * 0.25
  }% { transform: rotate(-5deg); }`;
  const thirdQuarter = `${
    wigglePercentage * 0.75
  }% { transform: rotate(5deg); }`;
  const end = `${wigglePercentage}%, 100% { transform: rotate(0deg); }`;

  const wiggleKeyframes = keyframes`
    ${start}
    ${firstQuarter}
    ${thirdQuarter}
    ${end}
  `;

  return css`
    animation: ${wiggleKeyframes} ${totalDuration}s ease-in-out infinite;
  `;
};

export const StyledPillText = styled.p`
  ${({ theme, size }) => theme.typography[size === 'small' ? 'label' : 'body']}
  ${({ theme }) => theme.fontFamily.condensed}
  ${({ theme, variant }) => theme.getContrastColors(variant)}
  padding: ${({ theme, size }) => {
    switch (size) {
      case 'small':
        return theme.spacing(3, 2, 3);
      case 'xLarge':
        return theme.spacing(4, 8);
      default:
        return theme.spacing(0.6, 4, 1);
    }
  }};
  height: ${({ size }) => (size === 'small' ? '16px' : '30px')};
  border-radius: 500px;
  text-transform: uppercase;
  width: max-content;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  ${(
    { $wiggle, $wiggleDelay }, //TODO: Potentially replace with proper animation when available/main ticket implemented
  ) => ($wiggle ? getWiggleAnimation(0.5, $wiggleDelay) : 'none')};
`;
